import request from './request';
// new
/**
 *  获取碰撞线索列表
 */
export function getCollisionList(params) {
    return request('/accident-clue/list', {
        method: 'POST',
        params,
    });
}
/**
 * 查询跟进记录
 */
export function getFollowRecord(params) {
    return request(`/accident-clue/${params.id}/follow/list`, {
        method: 'GET',
    });
}
/**
 * 跟进
 */
export function addFollowRecord(params) {
    return request(`/accident-clue/${params.id}/follow`, {
        method: 'POST',
        params,
    });
}
/**
 * GPS判断到店
 */
export function checkArrivedShop(params) {
    return request(`/accident-clue/${params.id}/gps-arrive`, {
        method: 'GET',
        params,
    });
}
/**
 * 确认到店
 */
export function arrivedShop(params) {
    return request(`/accident-clue/${params.id}/arrive-store`, {
        method: 'POST',
        params,
    });
}
/**
 * 未到店
 */
export function notArrived(params) {
    return request(`/accident-clue/${params.id}/not-arrived`, {
        method: 'PATCH',
        params,
    });
}
/**
 * 付费确认
 */
export function payConfirm(id) {
    return request(`/accident-clue/${id}/pay-confirm`, {
        method: 'POST',
    });
}
/**
 * 补全资料
 */
export function material(params) {
    return request(`/accident-clue/${params.id}/material`, {
        method: 'POST',
        params,
    });
}
/**
 * 查询审核信息
 */
export function getAuditInfo(params) {
    return request(`/accident-clue/${params.id}/audit`, {
        method: 'GET',
    });
}
/**
 * 修改碰撞报警类型
 */
export function editMessageType(params) {
    return request(`/accident-clue/${params.id}/alarm-type`, {
        method: 'PATCH',
        params,
    });
}
/**
 * 修改保险公司推送信息
 */
export function editPushData(params) {
    return request(`/accident-clue/${params.id}/insurance`, {
        method: 'PATCH',
        params,
    });
}
/**
 * 导出列表
 */
export function exportCollisionList() {
    return '/accident-clue/list/export';
}

/**
 * 获取碰撞线索详情 accident-clue/{id}
 */
export function getCollisionDetail(params) {
    // return request('/gaia/api/saas/accident-clue/{id}', {
    return request(`/accident-clue/${params.id}`, {
        method: 'GET',
    });
}

/**
 * 查询保险公司名称
 */
export function getInsuranceCompany() {
    return request('/accident-clue/insurance-company', {
        method: 'GET',
    });
}

/**
 * 获取碰撞线索操作记录
 */
export function getHistory(params) {
    return request(`/accident-clue/record/${params.id}`, {
        method: 'GET',
        params: {
            pageNum: params.pageNum,
            pageSize: params.pageSize,
        },
    });
}
// old
/**
 * 获取线索备注列表
 */
export function getCollisionRemarks(params) {
    return request('/collision/remarks', {
        method: 'GET',
        params,
    });
}

/**
 * 新增线索备注
 */
export function addCollisionRemark(params) {
    return request('/collision/:collisionId/remark', {
        method: 'POST',
        params,
    });
}
/**
 * 新增预约
 */
export function addOrder(params) {
    return request(`/collision/order/${params.collisionId}`, {
        method: 'POST',
        params,
    });
}

/**
 * 后补预约
 */
export function backedOrder(params) {
    return request(`/collision/order/backed/${params.collisionId}`, {
        method: 'POST',
        params,
    });
}

/**
 * 不回店
 */
export function addNotReturnRemark(params) {
    return request('/accident-clue/:collisionId/not-back', {
        method: 'POST',
        params,
    });
}

/**
 * 线索错误
 */
export function addErrorRemark(params) {
    return request('/collision/:collisionId/remark/error-collision', {
        method: 'POST',
        params,
    });
}
/**
 * 获取碰撞设置信息
 */
export function getCollisionSetting() {
    return request('/collision/setting', {
        method: 'GET',
    });
}
/**
 * 编辑碰撞设置信息
 */
export function editCollisionSetting(params) {
    return request('/collision/setting', {
        method: 'PATCH',
        params,
    });
}

/**
 * 查询线索责任人
 */
export function getAssignee() {
    return request('/accident-clue/assignees', {
        method: 'GET',
    });
}

/**
 * 编辑线索责任人
 */
export function editAssignee(id, params) {
    return request(`/accident-clue/${id}/assignee`, {
        method: 'POST',
        params,
    });
}

/**
 * 编辑线索调度
 */
export function editDispatch(id, params) {
    return request(`/accident-clue/${id}/dispatch`, {
        method: 'PUT',
        params,
    });
}

/**
 * 修改留修策略
 */
export function editRepairPolicy(params) {
    return request('/accident-clue/stay-repair-strategy', {
        method: 'PUT',
        params,
    });
}

/**
 * 查询接车短信接收人
 */
export function getSmsReceniver() {
    return request('/booking-order/pick-up/sms-receiver', {
        method: 'GET',
    });
}

/**
 * 查询相似线索（创建工单使用）
 */
export function getLikenessClue(params) {
    return request('/accident-clue/likeness', {
        method: 'POST',
        params,
    });
}


/**
 * 修改线索通用信息
 */
export function patchClueGeneralInfo(params) {
    return request('/accident-clue/general-info', {
        method: 'PATCH',
        params,
    });
}

/**
 * 合并线索
 */
export function mergeClue(params) {
    return request('/accident-clue/merge', {
        method: 'POST',
        params,
    });
}

/**
 * 合并线索确认
 */
export function mergeClueConfirm(params) {
    return request('/accident-clue/merge-confirm', {
        method: 'POST',
        params,
    });
}

/**
 * 合并线索
 */
export function relationWorkOrder(params) {
    return request('/accident-clue/relation-work-order', {
        method: 'POST',
        params,
    });
}

/**
 * 合并线索
 */
export function relationWorkOrderConfirm(params) {
    return request('/accident-clue/relation-work-order/confirm', {
        method: 'POST',
        params,
    });
}

/**
 * 查询事故-店铺距离
 */
export function getAccidentOrgDistance(params) {
    return request('/accident-clue/accident-org-distance', {
        method: 'POST',
        params,
    });
}

/**
 * 查询碰撞视频
 */
export function getCollisionVideo(params) {
    return request('/api/saas/accident-clue/video-url', {
        method: 'GET',
        params,
    });
}
